import React from 'react'
import styled, { keyframes } from 'styled-components'

const draw = keyframes`
  0% {
    stroke-dashoffset: 1.05;
  }
  45%,
  65% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -1.05;
  }
`

const Svg = styled.svg`
  flex: none;
  width: 32px;
  height: 32px;

  path {
    fill: none;
    stroke: #0225a1;
    stroke-width: 7.2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 1 1.2;
    stroke-dashoffset: 0;
  }

  &.loading path {
    animation: ${draw} 2.6s cubic-bezier(0.65, 0, 0.35, 1) infinite;
  }

  &.loading .line-b {
    animation-delay: 0.25s;
  }

  @media (prefers-reduced-motion: reduce) {
    &.loading path {
      animation: none;
    }
  }
`

interface LoadingLogoProps {
  loading?: boolean
}

/** Finadeck logo mark as inline SVG so its strokes can be animated while data is loading. */
const LoadingLogo: React.FC<LoadingLogoProps> = ({ loading }) => (
  <Svg
    viewBox="0 0 121 120"
    className={loading ? 'loading' : undefined}
    role="img"
    aria-label="finadeck"
    aria-busy={loading}
  >
    <g transform="matrix(.99 0 0 .99 6.6 -1.8)">
      <path className="line-a" pathLength={1} d="M10 67.2 37.9 27.1 64.7 71.1 99.9 11.4" />
      <path className="line-b" pathLength={1} d="M6.6 104.9 59.1 26.1 85.3 71.1 100.2 44.1" />
    </g>
  </Svg>
)

export default LoadingLogo
